import { Breakpoints } from './types';

export const breakpointSizes: Breakpoints = {
  sm: '480px',
  md: '768px',
  lg: '992px',
  xl: '1250px',
  xxl: '1550px',
};
